import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        // justifyContent: "flex-end",
        // marginHorizontal: 20
    },
    content: {
        backgroundColor: "#fff",
        paddingHorizontal: 20,
        paddingVertical: 25,
        borderRadius: 10,
        borderTopRightRadius: 10
    },
    closeIcon: {
        flexDirection: "row",
        justifyContent: "flex-end"
    },
    modalContent: {
        marginVertical: RFValue(10)
    },
    title: {
        textAlign: "center",
        marginVertical: 10
    }
})

export default styles
